import React, { cloneElement, Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useScribbleTooltip from '../../../../hooks/answeringQuestions/useScribbleTooltip';
import { setCorrectAnswerAction } from '../../../../redux/answeringQuestions/questionView';

function CorrectAnswerDevelop(props) {
  const dispatch = useDispatch();

  const isCorrectAnswer = useSelector(state => state.questionView.isCorrectAnswer);
  const setCorrectAnswer = payload => { dispatch(setCorrectAnswerAction(payload)) };

  const { hideScribbleTooltip } = useScribbleTooltip();

  const onCorrectAnswer = useCallback((e) => {
    setCorrectAnswer({
      isCorrectAnswer: !isCorrectAnswer
    });

    hideScribbleTooltip();
    e.stopPropagation();
  }, [isCorrectAnswer]);

  return cloneElement(props.children || <Fragment />, {
    onCorrectAnswer,
  });
}

export default CorrectAnswerDevelop;